import React, { Component } from 'react'

class PanelFooter extends Component {
    render() {
        const { children, cssClass, noDivider } = this.props
        return (
            <div className={`panelFooter ${cssClass || ''}`}>
                {!noDivider && <hr />}
                {children}
            </div>
        )
    }
}

export default PanelFooter
